import { CheckoutLines } from "@/common/lib/types";
import { giftTypes } from "@/apiUtils/constants";

function lineHasPositiveCharge(line: CheckoutLines): boolean {
  const total = line.totalPrice?.gross?.amount;
  if (total != null && total > 0.01) {
    return true;
  }
  const unit = line.unitPrice?.gross?.amount;
  return unit != null && unit > 0.01;
}

function lineHasCataloguePrice(line: CheckoutLines): boolean {
  const pricing = line.variant?.pricing;
  const catalog =
    pricing?.price?.gross?.amount ??
    pricing?.priceUndiscounted?.gross?.amount ??
    pricing?.costPrice?.gross?.amount ??
    0;
  return catalog > 0.01;
}

/**
 * Shared gift-line check — kept out of cartGiftUtils / promotionUtils so those
 * modules never import each other for this helper (avoids webpack circular load).
 *
 * BXGY paid parents often carry `appliedPromotions.giftType === FREE_GIFT` (reward
 * type on the trigger line). That alone must not classify a charged line as a gift.
 */
export function isCheckoutGiftLine(line?: CheckoutLines | null): boolean {
  if (!line) {
    return false;
  }

  if (line.isGift || line.isBuyxGetyGift || line.buyGetGiftFlag) {
    return true;
  }

  // Saleor marks buy-X parents with isGift/isBuyxGetyGift false even when FREE_GIFT
  // reward metadata is attached — never treat those as free-gift rows.
  if (line.isGift === false && line.isBuyxGetyGift === false) {
    if (lineHasPositiveCharge(line) || lineHasCataloguePrice(line)) {
      return false;
    }
  }

  // Charged merchandise (BXGY buy-X parent) is never a free-gift line.
  if (lineHasPositiveCharge(line)) {
    return false;
  }

  return line.appliedPromotions?.some((promo) => promo.giftType === giftTypes.FREE_GIFT) ?? false;
}
